export interface PackDefinition {
  label: string
  description: string
  monthlyPriceEnvVar: string
  annualPriceEnvVar: string
}

export const PACK_CATALOG: Record<string, PackDefinition> = {
  inventory_pack: {
    label: 'Inventory & Equipment',
    description: 'Track tools, vehicles, and consumables. Assign to jobs or crew.',
    monthlyPriceEnvVar: 'VITE_STRIPE_PRICE_INVENTORY_PACK_MONTHLY',
    annualPriceEnvVar: 'VITE_STRIPE_PRICE_INVENTORY_PACK_ANNUAL',
  },
}
